import { useEffect, useContext } from 'react';
import LanguageContext from '../contexts/LanguageContext';

const SEOHead = () => {
  const { language } = useContext(LanguageContext);

  useEffect(() => {
    document.title = language === 'en'
      ? 'Digital Sidekick - Expert Guidance. Real Conversations. | Your Personal AI Team'
      : 'Digital Sidekick - Eksperckie Wskazówki. Prawdziwe Rozmowy. | Twój Osobisty Zespół AI';

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content',
        language === 'en'
          ? 'An AI platform giving you instant access to specialized experts through natural, human conversations. Interview coach, life strategist, language tutor, AI chef and more — available 24/7.'
          : 'Platforma AI, która daje natychmiastowy dostęp do wyspecjalizowanych ekspertów poprzez naturalne, ludzkie rozmowy. Trener rozmów, strateg życiowy, korepetytor językowy, kucharz AI i więcej — dostępni 24/7.'
      );
    }

    document.documentElement.lang = language === 'en' ? 'en' : 'pl';

    const ogLocale = document.querySelector('meta[property="og:locale"]');
    if (ogLocale) {
      ogLocale.setAttribute('content', language === 'en' ? 'en_US' : 'pl_PL');
    }
  }, [language]);

  return null;
};

export default SEOHead;
